module.exports = {
          srcSet: __webpack_public_path__ + "a64686d6c97c3d1199260c6d1978bf82-640.png"+" 640w",
          images:[ {path: __webpack_public_path__ + "a64686d6c97c3d1199260c6d1978bf82-640.png",width: 640,height: 180}],
          src: __webpack_public_path__ + "a64686d6c97c3d1199260c6d1978bf82-640.png",
          toString:function(){return __webpack_public_path__ + "a64686d6c97c3d1199260c6d1978bf82-640.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAADCAIAAAAlXwkiAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAY0lEQVR4nGNQtwlTsw7SsAlWNvVRMvbUsvLTMPOS13GU0bSV07JlULEKVrMO1rAKUjbxVjH1UjZyV9R3ltexl1K3FlcyZVCzCla3DlY08QFJm3jK6TpJa9pKqVtLKJuLKpoAAGr3EgZkqKkrAAAAAElFTkSuQmCC",
          width: 640,
          height: 180
        }